import React from 'react';
import { connect, useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import TreatmentDetails from './TreatmentDetails';
import { jobDetailsForm } from '../../constants/FormConstants';

const TreatmentDetailsContainer = (props) => {
  const { treatmentTypeDetails } = props;

  const currentJob = useSelector((state) => state.currentJob);
  //const formValues = useSelector((state) => formValueSelector(jobDetailsForm)(state));
  const formValues = useSelector((state)=>state.form.jobDetailsForm)
  const referenceData = useSelector((state) => state.referenceData);
  const clientDetails = useSelector((state) => state.clientDetails);
  const treatmentTypes = useSelector((state)=>state.referenceData.treatmentTypes)
  const jobStandards = useSelector((state)=>state.referenceData.jobStandards) 
  const treatmentId =
    clientDetails != null && currentJob&&currentJob.treatmentDetails
      ? currentJob.treatmentDetails.treatmentTypeId
      : formValues.values.treatmentDetails.treatmentTypeId;
  const standardId =currentJob&& currentJob.treatmentDetails&&currentJob.treatmentDetails.standardId || props.standardId?props.standardId:null;
  const comment = currentJob&&currentJob.treatmentDetails && currentJob.treatmentDetails.comments || null;

  const endPointReadingPercentage =
    currentJob && currentJob.treatmentDetails&& currentJob.treatmentDetails.endPointReadingPercentage || null;
  return (
    <TreatmentDetails
      {...props}
      treatmentTypes = {treatmentTypes}
      endPointReadingPercentage={endPointReadingPercentage}
      comment={comment}
      treatmentTypeDetails={treatmentTypeDetails}
      treatmentId={formValues.values.treatmentDetails&&formValues.values.treatmentDetails.treatmentTypeId || treatmentId}
      standardId={standardId}
      jobStandards={jobStandards}
      referenceData={referenceData} // Pass reference data

    />
  );
};

export default connect()(TreatmentDetailsContainer);
